import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// fix：重复路径跳转报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/index/index.vue'),
      meta: {
        title: '首页',
        activeId: 'index',
      },
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../views/news/index.vue'),
      meta: {
        title: '资讯',
        activeId: 'news',
      },
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import('../views/newsDetail/index.vue'),
      meta: {
        title: '资讯详情',
        activeId: 'news',
      },
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('../views/activity/index.vue'),
      meta: {
        title: '活动',
        activeId: 'activity',
      },
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: () => import('../views/activityDetail/index.vue'),
      meta: {
        title: '活动详情',
        activeId: 'activity',
      },
    },
    {
      path: '/teams',
      name: 'teams',
      component: () => import('../views/teams/index.vue'),
      meta: {
        title: '团队',
        activeId: 'teams',
      },
    },
    {
      path: '/teamsDetail',
      name: 'teamsDetail',
      component: () => import('../views/teamsDetail/index.vue'),
      meta: {
        title: '团队',
        activeId: 'teams',
      },
    },
    {
      path: '/wishs',
      name: 'wishs',
      component: () => import('../views/wishs/index.vue'),
      meta: {
        title: '微心愿',
        activeId: 'wishs',
      },
    },
    {
      path: '/wishsDetail',
      name: 'wishsDetail',
      component: () => import('../views/wishsDetail/index.vue'),
      meta: {
        title: '微心愿详情',
        activeId: 'wishs',
      },
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('../views/download/index.vue'),
      meta: {
        title: '资料下载',
        activeId: 'download',
      },
    },
    {
      path: '/downloadDetail',
      name: 'downloadDetail',
      component: () => import('../views/downloadDetail/index.vue'),
      meta: {
        title: '资料下载详情',
        activeId: 'download',
      },
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('../views/help/index.vue'),
      meta: {
        title: '帮助中心',
        activeId: 'help',
      },
    },
  ],
});

export default router;
